/**
 * Opt-out attributes for password managers, spread onto the native <input> element
 * (via MUI's `inputProps` / `slotProps.htmlInput`).
 *
 * Password managers ignore `autocomplete="off"` and autofill identity data (e.g. the user's
 * email) into search/typeahead boxes where it doesn't belong. Each major manager honors its
 * own opt-out attribute below. Only use on non-credential fields (search, filters, typeaheads),
 * never on real form fields where users rely on autofill.
 */
export const passwordManagerIgnoreProps = {
  'data-lpignore': 'true', // LastPass
  'data-1p-ignore': 'true', // 1Password
  'data-bwignore': 'true', // Bitwarden
  'data-form-type': 'other' // Dashlane
};
